<template>
    <div>
        <button
            v-if="book"
            @click="getCategories(); showCategoriesInBook();"
            class="bg-teal search-button search-button me-1"
            type="button"
            :data-bs-target="'#openCategories' + id">
            <svg width="16" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="text-white"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"></path></svg>
        </button>

        <button
            v-else
            @click="getCategories()"
            class="bg-teal search-button search-button me-1"
            type="button"
            data-bs-toggle="modal"
            :data-bs-target="'#openCategories' + id">
            <svg width="16" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="text-white"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"></path></svg>
        </button>

        <div class="modal fade categories-modal" :id="'openCategories' + id" tabindex="-1" aria-labelledby="openCategoriesLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content modal-block">
                    <div class="modal-close-button box-shadow">
                        <button type="button" class="btn-close btn-close-white p-2" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body modal-block-content mx-auto box-shadow position-relative">
                        <div class="line line-left">
                            <label class="h2-like bg-white-like" for="openCategoriesTextarea">Toutes les rubriques</label>
                        </div>

                        <div v-if="results.length" class="categories-list mt-4" id="rubriquesListModal">
                            <div class="category-item mb-2">
                                <h2 class="category-header mb-0" id="all-categories-modal">
                                    <button class="accordion-like-button d-flex align-items-center"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#all-categories-subcategories-modal"
                                            aria-expanded="false"
                                            aria-controls="all-categories-subcategories-modal">
                                        <img src="/images/categories/60x60/0.png" alt="Nos bonnes adresses" class="accordion-like-icon">

                                        <a @click.prevent="add('Nos bonnes adresses')" href="#" class="category-title clickable-item" data-bs-dismiss="modal">Nos bonnes adresses</a>
                                    </button>
                                </h2>
                            </div>

                            <div v-for="category in results" class="category-item mb-2">
                                <h2 class="category-header mb-0" :id="category.slug + '-modal'">
                                    <button class="accordion-like-button d-flex align-items-center"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="'#' + category.slug + '-subcategories-modal'"
                                            aria-expanded="false"
                                            :aria-controls="category.slug  + '-subcategories-modal'">
                                        <img :src="'/images/categories/60x60/' + category.id  + '.png'" :alt="category.name" class="accordion-like-icon">

                                        <a @click.prevent="add(category.name)" href="#" class="category-title clickable-item" data-bs-dismiss="modal" v-html="category.name"></a>

                                        <a class="accordion-like-arrow d-flex align-items-center justify-content-center"><img class="arrow" src="/images/arrow--to-left.png" alt="arrow"></a>
                                    </button>
                                </h2>

                                <div :id="category.slug + '-subcategories-modal'" class="accordion-collapse collapse" :aria-labelledby="category.slug + '-modal'" data-bs-parent="#rubriquesListModal">
                                    <div v-if="category.subcategories.length" class="category-body bg-white w-100 p-3 mb-3">
                                        <ul class="list-unstyled ms-4 mb-0">
                                            <li v-for="subcategory in category.subcategories">
                                                <a @click.prevent="add(subcategory.name)" href="#" class="link-like subcategory-link clickable-item" data-bs-dismiss="modal" :title="subcategory.name" v-html="subcategory.name"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="d-flex justify-content-center mx-auto spinner-border text-primary" role="status">
                                <span class="visually-hidden">Chargement...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: Number,
            required: false
        },
        book: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            results: []
        }
    },

    mounted() {
    },

    methods: {
        add(result) {
            let what = document.querySelector('#what');
            if (this.book) {
                what = document.querySelector('#whatBook');
            }

            if (what) {
                what.value = result;
            }
            this.results = [];
        },
        getCategories() {
            if (this.abortController) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();
            this.results = [];
            axios.get('/api/v1/globalCategories/', {
                signal: this.abortController.signal,
            }).then(response => {
                this.results = response.data;
            }).catch(err => {
                return err;
            });
        },
        showCategoriesInBook() {
            const myModal = new bootstrap.Modal('#openCategories' + this.id);
            if(myModal) {
                myModal.show();
            }
        }
    }
};
</script>
